const camposPetroleros = [
  { nombre: 'Ayacucho', descripcion: 'Faja Petrolífera del Orinoco' },
  { nombre: 'Carabobo', descripcion: 'Faja Petrolífera del Orinoco' },
  { nombre: 'Junín', descripcion: 'Faja Petrolífera del Orinoco' },
  { nombre: 'Boyacá', descripcion: 'Faja Petrolífera del Orinoco' },
];

const caracteristicasTecnicas = [
  'Fabricado por Rixin Corp, China',
  'Aprobado en laboratorios de PDVSA',
  'Validado en pruebas de botella en cada campo',
  'Producto ya formulado, listo para usar',
  'Soporte técnico en sitio por Poly Alphas',
  'Disponibilidad inmediata en Venezuela',
];

export default function ProductDetail() {
  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 lg:px-16">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-5">
              <i className="ri-flashlight-line text-sm w-4 h-4 flex items-center justify-center" />
              Producto Importado
            </div>
            <p className="text-foreground-500 text-xs md:text-sm font-medium tracking-wide uppercase mb-3">
              RIXIN CORP CHINA → RESINVENCA RESINAS DE VENEZUELA C.A. VENEZUELA
            </p>
            <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4">
              Demulsificante{' '}
              <span className="text-primary-500">Importado y Listo para Usar</span>
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
              Demulsificante ya formulado por Rixin Corp en China, importado por RESINVENCA RESINAS DE VENEZUELA C.A. y aprobado 
              en los laboratorios de PDVSA. Eficacia superior en los campos petroleros más exigentes de Venezuela.
            </p>
          </div>

          <div className="bg-background-50 rounded-lg border border-background-200/60 p-6 md:p-10">
            <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-12">
              <div className="lg:col-span-3">
                <div className="flex items-start gap-4 mb-6">
                  <div className="w-14 h-14 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 flex-shrink-0">
                    <i className="ri-oil-line text-2xl" />
                  </div>
                  <div>
                    <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-2">
                      Demulsificante para Crudo
                    </h3>
                    <p className="text-foreground-500 text-sm">
                      Formulación de alto rendimiento fabricada por Rixin Corp, China, para la separación agua-crudo en sistemas de producción petrolera
                    </p>
                  </div>
                </div>

                <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-6 text-justify">
                  Este demulsificante es importado directamente desde las instalaciones de{' '}
                  <strong className="text-foreground-900">Rixin Corp en China</strong>, donde es formulado 
                  y producido bajo estrictos estándares internacionales. El producto llega a Venezuela 
                  ya terminado, listo para usar, y ha sido diseñado específicamente para las características 
                  de los crudos venezolanos, especialmente los crudos pesados y extrapesados de la Faja 
                  Petrolífera del Orinoco.
                </p>

                <div className="inline-flex items-center gap-3 bg-primary-50 border border-primary-200/50 rounded-lg px-5 py-3 mb-8">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 text-background-50">
                    <i className="ri-government-line text-lg" />
                  </div>
                  <div>
                    <p className="text-primary-700 font-semibold text-sm">Aprobado por Laboratorios PDVSA</p>
                    <p className="text-primary-500 text-xs">Certificado en pruebas de botella y análisis fisicoquímico en Venezuela</p>
                  </div>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
                  {caracteristicasTecnicas.map((caract) => (
                    <div key={caract} className="flex items-center gap-2">
                      <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                        <i className="ri-check-double-line text-primary-500 text-sm" />
                      </div>
                      <span className="text-foreground-700 text-xs">{caract}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="lg:col-span-2">
                <div className="bg-background-100 rounded-lg p-6 md:p-8 h-full">
                  <div className="flex items-center gap-2 mb-6">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-map-pin-2-line text-primary-600 text-sm" />
                    </div>
                    <h4 className="text-foreground-950 font-heading text-base font-semibold">
                      Campos Petroleros Aprobados
                    </h4>
                  </div>

                  <p className="text-foreground-500 text-xs mb-6">
                    Faja Petrolífera del Orinoco
                  </p>

                  <div className="space-y-3">
                    {camposPetroleros.map((campo) => (
                      <div
                        key={campo.nombre}
                        className="flex items-center gap-4 p-3.5 rounded-lg bg-background-50 border border-background-200/60 hover:border-primary-300/60 transition-all duration-300"
                      >
                        <div className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-100 text-primary-600 flex-shrink-0">
                          <i className="ri-oil-line text-base" />
                        </div>
                        <div>
                          <p className="text-foreground-950 font-semibold text-sm">{campo.nombre}</p>
                          <p className="text-foreground-500 text-xs">{campo.descripcion}</p>
                        </div>
                        <div className="ml-auto w-5 h-5 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 flex-shrink-0">
                          <i className="ri-check-line text-xs" />
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="mt-6 pt-4 border-t border-background-200/60 text-center">
                    <p className="text-foreground-500 text-xs">
                      <span className="text-primary-600 font-bold text-base">4</span> campos activos
                    </p>
                    <p className="text-foreground-400 text-xs mt-0.5">con aprobación vigente</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}